import { TimelineItem } from "./TimelineItem";

function Timeline({data}) {

    return (
        <ul className="main-about__history-timeline">
            {data.map((time, i) => <TimelineItem year={time.year} points={time.points} key={i}></TimelineItem>)}
        </ul>
    )
}

export { Timeline }